import { useCallback, useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Checkbox from "@mui/joy/Checkbox";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
import Menu from "@mui/joy/Menu";
import Dropdown from "@mui/joy/Dropdown";
import Chip from "@mui/joy/Chip";
import { SxProps } from "@mui/joy/styles/types";
import { OptionObj } from "@/types/interfaces/common";

// type Props = {
//   placeholder: string;
//   options: OptionObj[];
//   value: string[];
//   setValue: React.Dispatch<React.SetStateAction<string[]>>;
// } & (
//   | {
//       showAllOption?: true;
//       showAll: boolean;
//       setShowAll: React.Dispatch<React.SetStateAction<boolean>>;
//     }
//   | {
//       showAllOption?: false;
//       showAll?: undefined;
//       setShowAll?: undefined;
//     }
// );

interface Props {
  placeholder: string;
  options: OptionObj[];
  value: string[];
  setValue: React.Dispatch<React.SetStateAction<string[]>>;
  maxHeight?: string;
  size?: "sm" | "md" | "lg";
  sx?: SxProps;
  // shows the selected option's label instead of the static placeholder when exactly one is selected
  showSelectionLabel?: boolean;
}

const MultiSelectFilterBox = ({
  placeholder,
  options,
  value,
  setValue,
  maxHeight,
  size = "sm",
  sx,
  showSelectionLabel,
}: Props) => {
  const menuButtonRef = useRef(null);
  const menuRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const handleChange = useCallback(
    (newValue: string) => {
      if (value.includes(newValue)) {
        if (newValue === "") {
          // uncheck all, because "" is considered as "All" option
          setValue([]);
        } else {
          setValue((prevValue) => prevValue.filter((v) => v !== newValue));
        }
      } else {
        if (newValue === "") {
          // check all, because "" is considered as "All" option
          setValue(options.map((o) => o.value));
        } else {
          setValue((prevValue) => [...prevValue, newValue]);
        }
      }
    },
    [value, setValue, options],
  );

  const buttonLabel =
    showSelectionLabel && value.length === 1
      ? options.find((o) => o.value === value[0])?.label || placeholder
      : placeholder;

  useEffect(() => {
    const handler = (e: any) => {
      // @ts-ignore
      if (isOpen && !menuRef?.current?.contains(e.target) && !menuButtonRef?.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handler);

    return () => document.removeEventListener("click", handler);
  }, [isOpen, menuRef, menuButtonRef]);

  return (
    <Dropdown open={isOpen}>
      <MenuButton
        ref={menuButtonRef}
        onClick={() => setIsOpen((prevValue) => !prevValue)}
        endDecorator={
          <>
            {value.length > 0 && (
              <Chip size={size} color="primary">
                {value.length}
              </Chip>
            )}
            <KeyboardArrowDownIcon />
          </>
        }
        size={size}
        sx={[
          {
            py: 1.18,
            fontWeight: "sm",
            bgcolor: "white",
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {buttonLabel}
      </MenuButton>

      <Menu
        ref={menuRef}
        size={size}
        popperOptions={{
          placement: "bottom-start",
        }}
        sx={{
          minWidth: "200px",
          maxHeight,
        }}
      >
        {options.map((o) => (
          <MenuItem
            component={Checkbox}
            size={size}
            label={o.label}
            value={o.value}
            checked={value.includes(o.value)}
            // @ts-ignore
            onChange={(e) => handleChange(e.target?.value!)}
          />
        ))}
      </Menu>
    </Dropdown>
  );
};
export default MultiSelectFilterBox;
